import { useEffect } from 'react';

export default function Lightbox({ image, images, onClose, onSelect }) {
  useEffect(() => {
    if (!image) return undefined;

    function onKeyDown(event) {
      if (event.key === 'Escape') onClose();
      if (event.key === 'ArrowRight') {
        const index = images.findIndex((item) => item.id === image.id);
        onSelect(images[(index + 1) % images.length]);
      }
      if (event.key === 'ArrowLeft') {
        const index = images.findIndex((item) => item.id === image.id);
        onSelect(images[(index - 1 + images.length) % images.length]);
      }
    }

    document.addEventListener('keydown', onKeyDown);
    document.body.classList.add('is-lightbox-open');
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.classList.remove('is-lightbox-open');
    };
  }, [image, images, onClose, onSelect]);

  if (!image) return null;

  return (
    <div className="lightbox" role="dialog" aria-modal="true" aria-label="Bildansicht">
      <button className="lightbox__close" type="button" onClick={onClose}>
        Close
      </button>
      <button
        className="lightbox__nav lightbox__nav--prev"
        type="button"
        onClick={() => {
          const index = images.findIndex((item) => item.id === image.id);
          onSelect(images[(index - 1 + images.length) % images.length]);
        }}
      >
        Prev
      </button>
      <img src={image.src} alt={image.title || image.filename} />
      <button
        className="lightbox__nav lightbox__nav--next"
        type="button"
        onClick={() => {
          const index = images.findIndex((item) => item.id === image.id);
          onSelect(images[(index + 1) % images.length]);
        }}
      >
        Next
      </button>
      <p>
        {image.title || image.filename} / {image.orientation}
      </p>
    </div>
  );
}
